import "./loading.scss";
import { LoadingSpinner as LoadingSpinnerShared } from "@shared/src";

interface ISpinner {
  position?: "fixed" | "absolute";
  backgroundColor?: string;
  zIndex?: number;
}

/**
 * 로딩 스피너
 */
const LoadingSpinner = ({
  position = "fixed",
  backgroundColor = "rgba(255, 255, 255, 0.9)",
  zIndex,
}: ISpinner) => {
  return (
    <>
      {/* <div
        className="loading-spinner"
        style={{
          position: `${position}`,
          backgroundColor: `${backgroundColor}`,
          zIndex: `${zIndex}`,
        }}
      >
        <div className="spinner">
          <span className=""></span>
        </div>
      </div> */}
      <LoadingSpinnerShared position={position} backgroundColor={backgroundColor} zIndex={zIndex} />
    </>
  );
};

export default LoadingSpinner;
